export default __webpack_public_path__ + "static/media/ai-waves.b733aa7c.png";